/* eslint-disable */
import React, { FC, useEffect, useState } from 'react';
import { Button, Progress, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WizardContent from '~/layouts/WizardContent';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import features from '~/constants/features';
import LeftLayout from '~/layouts/LeftLayout';
import { useGetServices } from '~/controllers/pricing';

import { useGetApplication } from '~/controllers/wizard';
import ServicesForm from './ServicesForm';
import RightContent from './ServicesRightContent';
import ApplicationNavigation from '~/layouts/uae/ApplicationNavigation';
import ContentHeader from '~/components/ContentHeader';
import { useIsMobile } from '~/hooks/useScreenSizes';
import paths from '~/pages/paths';
import { getMobileNumber } from '~/utils/getDecodedJwt';
import { sendInitialData } from '~/api/validate';
import { useHistory } from 'react-router';
export const servicesFormName = 'services';
export const servicesStepKey = servicesFormName;
type SelectServicesProps = {
  setbackToInitial?: () => void;
};
const SelectServices: FC<SelectServicesProps> = (props: any) => {
  const { setbackToInitial } = props;
  const { t } = useTranslation('ksaApplication');
  const isMobile = useIsMobile();
  const servicesQuery = useGetServices();
  const application = useGetApplication()
  const history = useHistory();;

  useEffect(() => {
    const stageRedirectMap: Record<string, string> = {
      ksaTerminated: paths.ksa.terminated,
      ksaReviewReject: paths.ksa.reviewReject,
    };
    const callInitialApi = async () => {
      try {
        const utm =
          localStorage.getItem('utm-saved-param') ||
          localStorage.getItem('utmUrlState') ||
          localStorage.getItem('redirectUrlParams') ||
          localStorage.getItem('urlParams') ||
          '{}';
        const trackingId = localStorage.getItem('tracking_id') || '{}';
        const config = { ...JSON.parse(utm), trackingId };
        const mobileNumber = getMobileNumber();
        const res = await sendInitialData({ utm: JSON.stringify(config), mobileNumber });
        console.log('Initial API called successfully');

        // If the user is already terminated, redirect them immediately        
        const redirectPath = stageRedirectMap[res?.stage];
        if (redirectPath) {
          history.push(redirectPath);
          return;
        }
      } catch (error: any) {
        // If the application is already terminated/rejected (400), redirect immediately
        if (
          error?.response?.status === 400 &&
          error?.response?.data?.code === 'APPLICATION_TERMINATED_OR_REJECTED'
        ) {
          history.push(paths.ksa.terminated);
        }
      }
    };

    callInitialApi();
  }, []);


  // const isTenantConfigurationUpdated = application.data?.payload?.tenantConfigNotificationRequired ?? false;
  return (
    <StyledWizardContent
      left={
        <>
          <LeftLayout>
            <ApplicationNavigation />
          </LeftLayout>
        </>
      }
      content={
        <>
          <ContentHeader
            title={t('Select Products')}
            subtitle={t('Choose from the options below:')}
            stageNumber={1}
          />
          <ServicesForm />
          {/* Confirm button: fixed at bottom on mobile, inline on desktop */}
          <ButtonWrapper isMobile={isMobile}>
            <RightContent />
          </ButtonWrapper>
        </>
      }
      right={<></>}
      className="SelectServices"
    />
  );
};

const ButtonWrapper = styled.div<{ isMobile?: boolean }>`
  ${({ isMobile }) =>
    isMobile
      ? `
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background: #ffffff;
        padding: 16px;
        box-shadow: 0px 4px 16px rgba(0, 89, 150, 0.08);
      `
      : `
        margin-top: auto;
        padding-top: 32px;
      `}
`;

const StyledWizardContent = styled(WizardContent)`
  /* Make the white card a flex column so ButtonWrapper with margin-top:auto
     sticks to the bottom of the card */
  .MainContent {
    display: flex;
    flex-direction: column;
  }
  h1 {
    margin-bottom: 16px;
  }
  /* Confirm button: taller height scoped only to this Select Products page */
  #WizardContinueButton {
    height: 52px !important;
    min-height: 52px !important;
  }
`;

export default SelectServices;
